<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{data.invoice?.name}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <div class="scroll-content-padding dialog-form df-c gap20">
        <div class="key-value grid gap10">
            <span class="key">Від компанії</span>
            <span class="value">{{data.invoice?.dahCounterParty?.name ? data.invoice.dahCounterParty?.name : ''}}</span>

            <span class="key">Договір</span>
            <span class="value">{{data.invoice?.contract?.name ? data.invoice.contract?.name : ''}}</span>

            <span class="key">Дата</span>
            <span class="value">{{data.invoice.date | date: 'dd.MM.yyyy HH:mm'}}</span>

            <span class="key">Період</span>
            <span class="value">{{data.invoice.period}}</span>

            <span class="key">Номер</span>
            <span class="value">{{data.invoice.number}}</span>

            <span class="key">Відправлено клієнту</span>
            <span class="value">
                <span *ngIf="data.invoice.sentAt">{{data.invoice.sentAt | date: 'dd.MM.yyyy HH:mm'}}</span>
                <span *ngIf="!data.invoice.sentAt && data.invoice.sendPending">В черзі на відправку</span>
                <span *ngIf="!data.invoice.sentAt && !data.invoice.sendPending">Не відправлено</span>
            </span>

            <span class="key">Сума</span>
            <span class="value df gap10">
                <span>{{data.invoice.amount | currency:'UAH': 'грн.':'0.2-2'}}</span>
                <button class="item-action-button gray" (click)="amount.setValue(data.invoice.amount); comment.setValue(data.invoice.comment); amountEdit = true">
                    <mat-icon>edit</mat-icon>
                </button>
                <button class="item-action-button gray" [disabled]="!data.invoice.invoiceLink" (click)="openLink()"
                        matTooltip="Переглянути файл рахунку" matTooltipClass="tooltip">
                    <mat-icon>link</mat-icon>
                </button>
            </span>
        </div>

        <div *ngIf="amountEdit" class="df gap10 jc-s ai-c">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px; max-width: 120px">
                <mat-label>{{'modules.billing.agreements.agreementDialog.labels.amount' | translate}}</mat-label>
                <input type="number" matInput [formControl]="amount" step=".01">
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width grow">
                <mat-label>Коментар</mat-label>
                <input type="text" matInput [formControl]="comment">
            </mat-form-field>
            <span class="add-row" (click)="submitForm(false, true)">Зберегти</span>
            <span class="cancel" (click)="closeEditAmount()">Відмінити</span>
        </div>

        <form [formGroup]="paymentForm" class="dialog-form no-top-margin no-overflow df-c gap20" autocomplete="off">
            <div class="df jc-sb ai-c gap15">
                <b>Платежі</b>
                <mat-divider class="grow"></mat-divider>
                <span class="add-row" (click)="addFormArrayItem()">{{'common.addItem' | translate}}</span>
            </div>
            <span class="hint">Рознесення рахується автоматично: тут лише обирають, які платежі належать цьому договору.</span>

            <div class="scroll-content-padding scrollable">
                <div formArrayName="paymentFormControls" *ngFor="let paymentFormControls of getControls(); let i = index"
                     class="form-array-controls-container">
                    <div [formGroupName]="i" class="df gap20 ai-c">
                        <autocomplete-item-field label="{{'Платіж'}}"
                                                 class="grow"
                                                 formControlName="payment"
                                                 [dataType]="'TRANSACTION'"
                                                 [canOpenList]="true"
                                                 [canOpenItem]="true"
                                                 [props]="{contract: data.contract, dahCounterParty: data.invoice.dahCounterParty}"
                                                 [selector]="{translation: 'common.dialog.listDialog.labels.TRANSACTION.statuses', options: [true, false]}"
                        ></autocomplete-item-field>

                        <span style="width: 120px; min-width: 120px; max-width: 120px">
                            {{getCoveredAmount(i) | currency:'UAH': 'грн.':'0.2-2'}}
                        </span>

                        <div class="df ai-c jc-c">
                            <button class="delete-form-control-button" (click)="deleteFormArrayItem(i)">
                                <mat-icon>delete_outline</mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="df-c gap10" *ngIf="history.length">
            <div class="df jc-sb ai-c gap15">
                <b>Історія</b>
                <mat-divider class="grow"></mat-divider>
            </div>
            <div class="df gap20" *ngFor="let item of history">
                <span>{{item.created | date: 'dd.MM.yyyy HH:mm'}}</span>
                <span>{{item.action == 'ACT_CREATED' ? 'Сформовано акт' : 'Перенесено'}}</span>
                <span class="grow">{{item.details}}</span>
                <span>{{item.createdBy}}</span>
            </div>
        </div>
    </div>
</div>
<div class="buttons-row df jc-sb ai-c gap20">
    <div class="key-value grid gap10">
        <ng-container *ngIf="getUnhandled()">
            <span class="key">Неоплачено</span>
            <span class="value warning">{{getUnhandled() | currency:'UAH': 'грн.':'0.2-2'}}</span>
        </ng-container>
    </div>
    <div class="df jc-e ai-c gap20">
        <button class="default-button apply-button-flat" (click)="submitForm(false)"
                [disabled]="paymentForm.invalid && (loading$ | async) === false">
            {{'common.save' | translate}}
        </button>
        <button class="default-button apply-button" (click)="submitForm(true)" [disabled]="paymentForm.invalid && (loading$ | async) === false">
            {{'common.saveAndClose' | translate}}
        </button>
    </div>
</div>
